<script>
import store from '@/store/store'
import {
  HubConnectionBuilder,
  HttpTransportType,
  LogLevel
} from '@microsoft/signalr'
import EventBus from '../../event-bus'
import translate from '@/utils/genTable/multilanguageHelper.js'

export default {
  name: 'BaseMapComponent',
  data() {
    return {
      wsConnection: null,
      showLoading: true
    }
  },
  props: {
    height: Number
  },
  created() {
    this.$logger('[i] BaseMapComponent created.')
  },
  mounted() {
    this.$logger('[i] BaseMapComponent mounted.')
    this.$logger('[i] Vuex dispatched [getAccessToken]')

    store
      .dispatch('map/getAccessToken', localStorage.getItem('user'))
      .then(() => {
        this.createWsConnection()
        this.setupWsEvents()
        this.startWsConnection()
      })
  },
  beforeDestroy() {
    this.wsConnection.stop()
    store.dispatch('map/clearVehicleData')
  },
  methods: {
    init() {},
    createWsConnection() {
      this.wsConnection = new HubConnectionBuilder()
        .withUrl(`${process.env.VUE_APP_API_DOMAIN}/vehiclestream`, {
          skipNegotiation: true,
          transport: HttpTransportType.WebSockets,
          accessTokenFactory: () => {
            return store.getters['map/accessToken']
          }
        })
        .withAutomaticReconnect()
        .configureLogging(LogLevel.Information)
        .build()
    },
    setupWsEvents() {
      if (!this.wsConnection) {
        this.$logger(
          `[x] Failed to establish ws connection: [${this.wsConnection}]`,
          'error'
        )

        return
      }

      this.wsConnection.on('InitialData', this.handleInitialData)
      this.wsConnection.on('VehicleData', this.handleVehicleData)
    },
    startWsConnection() {
      try {
        this.wsConnection.start()
      } catch (err) {
        setTimeout(this.startWsConnection, 3000)
      }
    },
    handleWSConnectionState() {
      this.wsConnection.onreconnecting(() => {        
        if(this.$route.name === 'GenericMapPage' && this.$route.params.slug === 'realtime') {
          store.dispatch('notification/add', {type: 'warning', message: translate('Connection lost, reconnecting', 'realtimeMap')}, { root: true })        
        }
      });
      this.wsConnection.onreconnected(() => {        
        if(this.$route.name === 'GenericMapPage' && this.$route.params.slug === 'realtime') {
          store.dispatch('notification/add', {type: 'success', message: translate('Reconnected', 'realtimeMap')}, { root: true })        
        }
      });
      this.wsConnection.onclose(() => {        
        if(this.$route.name === 'GenericMapPage' && this.$route.params.slug === 'realtime') {
          store.dispatch('notification/add', {type: 'error', message: translate('Connection lost, please try again later', 'realtimeMap')}, { root: true })
          store.dispatch('map/clearVehicleData')
        }
      });
    },
    async handleInitialData(initialData) {
      this.$logger(`Initial data length ${initialData.length}`)
      store.dispatch('map/saveVehicles', initialData)
      setTimeout(function() {
        EventBus.$emit('SET_ZOOM_LEVEL')
      }, 200)
      this.showLoading = false
      this.handleWSConnectionState()
    },
    async handleVehicleData(vehicleData) {
      EventBus.$emit('VEHICLE_STREAM_PACKET_ARRIVED', vehicleData)
      store.dispatch('map/updateVehicle', vehicleData)
    }
  }
}
</script>
